import styled, { css } from 'styled-components'
import { colors, Dialog } from '@microfrontends/react-components'

export const Section = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`

export const SectionContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`
export const WrapSwitcher = styled.div<{ isMobile: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 8px;
    gap: 16px;

    ${({ isMobile }) =>
        isMobile &&
        css`
            margin-top: 0;
            gap: unset;
            button.disable {
                color: #e5e5e5;
                border-color: #e5e5e5;
                pointer-events: none;
            }
        `}
`

export const SwitcherBox = styled.div<{ isMobile: boolean }>`
    margin-left: 100px;
    ${({ isMobile }) =>
        isMobile &&
        css`
            margin-left: 0;
        `}
    &.disable > div {
        pointer-events: none;
    }
    label {
        margin: 0 10px;
        user-select: none;
        font-weight: 400;
        cursor: pointer;
    }
`

export const StyledSwitcher = styled.div`
    min-width: 25%;
    width: auto;
    display: inline-flex;
    justify-content: flex-end;
    padding-left: 0;
    height: 28px;

    label {
        margin-bottom: 0;
    }
`
export const WrapRadio = styled.div<{ isMobile?: boolean }>`
    display: flex;
    width: 100%;
    transition: all 0.5s;
    margin-top: 20px;
    ${({ isMobile }) => {
        return (
            isMobile &&
            css`
                display: unset;
            `
        )
    }}
`
export const RefreshRadio = styled.div<{ checked: boolean }>`
    border-radius: 12px;
    background: ${({ checked }) => (checked ? '#f0f7ff' : colors.grey[99])};
    border: 1px solid ${({ checked }) => (checked ? '#b3ceff' : '#efefef')};
    &:hover {
        background: #f0f7ff;
        border: 1px solid #b3ceff;
    }
    & > label {
        padding: 12px;
        height: 48px;
        gap: 12px;
        & input {
            border-width: ${({ checked }) => (checked ? '2px ' : '1px ')}!important;
        }
    }
`
export const AlertBox = styled.div`
    margin-top: 1rem;
    margin-bottom: 1rem;
`
export const RefreshStatus = styled.div`
    flex: 1;
    color: rgb(51 51 51 / 70%);
`
export const StyledDialog = styled(Dialog)`
    div[class^='Dialog-module_body_'] {
        background-color: #fbfbfb;
        padding-left: 0px;
        padding-right: 0px;
    }
    .text-h2 {
        width: 100%;
        text-align: center;
    }
    span[class^='Dialog-module_icon__'] {
        position: absolute;
        left: 16px;
    }
`
export const WrapSwitcherMobile = styled.div`
    padding: 16px 12px;
    background: #fff;
    border-radius: 6px;
    border: 1px solid #ebebeb;
    margin-bottom: 8px;
`
